import { Button, ConfigProvider, Flex, Modal, Space, theme } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTerminal } from '@fortawesome/free-solid-svg-icons';
import { ErrorMessage } from '@shared/components/ErrorMessage';
import { LoadingIndicator } from '@shared/components/LoadingIndicator';
import { QUOTATION_INSURANCE_CARRIER_NON_TERMINAL_STATES } from '@shared/constants/quotationInsuranceCarrierStates';
import { useGetQuotationExecutionDetails } from '../../hooks/useQuotations';
import { SyncStatus } from './SyncStatus';
import { ExecutionOverview } from './ExecutionOverview';
import { ExecutionLog } from './ExecutionLog';

const defaultToken = theme.defaultAlgorithm(theme.defaultSeed);

export const ExecutionDetailsModal = ({ open, onClose, quotationId, quotationInsuranceCarrierId }) => {
  const { token: themeToken } = theme.useToken();
  const { data, isLoading, isFetching, isError, error, dataUpdatedAt } = useGetQuotationExecutionDetails({ quotationId, quotationInsuranceCarrierId }, { enabled: open, pollWhileNonTerminal: true });

  const isPolling = QUOTATION_INSURANCE_CARRIER_NON_TERMINAL_STATES.includes(data?.state);

  return (
    <ConfigProvider
      theme={{ token: { colorBorderSecondary: defaultToken.colorBorderSecondary } }} // Se restaura el color por defecto de los bordes
    >
      <Modal
        open={open}
        onCancel={onClose}
        title={(
          <Space>
            <FontAwesomeIcon icon={faTerminal} color={themeToken.colorPrimary} />
            Detalles de ejecución
          </Space>
        )}
        width={880}
        styles={{ body: { paddingTop: 12 } }}
        footer={(
          <Flex justify='space-between' align='flex-start' gap='middle'>
            <SyncStatus
              isPolling={isPolling}
              isFetching={isFetching}
              dataUpdatedAt={dataUpdatedAt}
            />
            <Button type='primary' onClick={onClose} style={{ marginLeft: 'auto' }}>
              Cerrar
            </Button>
          </Flex>
        )}
        destroyOnHidden
      >
        {isLoading ? (
          <LoadingIndicator />
        ) : isError ? (
          <ErrorMessage error={error} />
        ) : (
          <Flex vertical gap='middle'>
            <ExecutionOverview data={data} />
            <ExecutionLog data={data} />
          </Flex>
        )}
      </Modal>
    </ConfigProvider>
  );
};
